module.exports = "/_next/static/images/dingdanguanli-70559550c13599359be0e8f5e95b05c8.png";